import { RouteConfig } from '@abaco/web-common/src/app';

const routes: RouteConfig[] = [
    {
        name: "helper",
        path: "/helper",
        component: () => import("./components/HelperContainer.vue")
    },
    {
        name: "addModuleHelper",
        path: "add-module-helper",
        component: () => import("./components/HelperAddModule.vue")
    },
    {
        name: "support-page",
        path: "support",
        component: () => import("./components/HelperSingleTileContainer.vue"),
        props: {tileId: "helper-support-iframe"}
    }
];

export default routes;
